<template>
  <div id="issueMgContainer">
    <el-row>
      <el-col :span="24">
        <div class="mainHeader"> 问题列表 </div>
        <div class="mainBody" v-loading="bodyLoading">
          <div class="left">
            <ul class="mainNav">
              <li v-for="(item,index) in navList"  :class="{'isActive':active==index}" :key="index" @click.stop="navhandleClick(index)">{{item}}</li>
            </ul>
            <div class="issueOpter" v-if="active!=3">
              <el-button :disabled="isIssue" type="primary" size="mini" @click="openProbelmStatus" >批量处理问题</el-button >
              <el-button :disabled="isPeople" type="primary" size="mini"  plain @click="openModifyPartyName" >批量指定修改方</el-button >
              <el-button :disabled="isExport" type="primary" size="mini"  plain @click="acexportExcel" >导出Excel</el-button >
              <el-button type="danger" size="mini" :disabled="multipleSelection.length === 0"  plain @click="deleteQuestion" >删除问题</el-button >
              <el-input v-model="searchFileName" placeholder="请输入文件名称进行搜索" size="small" style="width:213px" class="searchRight" clearable @input="changeclear" @keyup.enter.native="submitForm" > <i slot="prefix" class="el-input__icon el-icon-search"></i ></el-input>
            </div>
            <div class="issueTable">
              <checkLabel2D v-if="active!=3" ref="checkLabel2D" :key="tableRefresh" @checkData="checkData" :typeArray="typeArray" @openDetail="openDetail" :searchFileName="searchFileName" />
              <problemStatistics v-else ref="problemStatistics" />
            </div>
          </div>
        </div>
        
      </el-col>
    </el-row>
    <!-- 导出excel -->
    <el-dialog v-dialogDrag :visible.sync="excelSelectVisiable" :close-on-click-modal="false" :close-on-press-escape="false" title="导出excel" >
      <div v-for="(item, index) in exportExcel" :key="index" class="openModify">
        <el-radio v-model="exportExcelradio" :label="item" :key="item">{{ item }}</el-radio>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="excelSelectCannel">取 消</el-button >
        <el-button :loading="excelDisable" type="primary" @click="excelSelectSure" >确 定</el-button >
      </div>
    </el-dialog>
    <!-- 处理问题弹出的数据 -->
    <el-dialog v-dialogDrag :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="批量处理问题" width="565px" class="piliangshuli" >
      <el-form label-position="left" label-width="110px">
        <el-form-item  label="数据范围：">
          <ul class="dataRangeStyle">
            <li v-for="(item,index) in dataRangelist" :key="index" :class="{'dataRangeSelect':issueSelect==item}" @click="changeDataRange(item)">
              {{item}}
            </li>
          </ul>
        </el-form-item>
        <!-- <el-form-item  label="处理人身份：">
          <ul class="identityStyle">
            <li v-for="(item,index) in identitylist" :key="index" :class="{'identitySelect':issueidentity==item}" @click="changeIdentity(item)">
              {{item}}
            </li>
          </ul>
        </el-form-item> -->
        <el-form-item  label="问题原始状态：">
          <ul class="prostatusStyle">
            <li v-for="(item,index) in issueStatus" :key="index" :class="{'prostatusSelect':prostatus==item.cnName}" @click="changeprostatus(item.cnName)">
              {{item.cnName}}
            </li>
          </ul>
        </el-form-item>
        <div class="countStyle">
          符合当前筛选条件的数据共<span>{{count}}</span>条
        </div>
        <el-form-item label="批量更改问题状态为：" label-width="155px" class="labletop" >
          <el-select v-model="selectStatus" filterable placeholder="问题状态">
            <el-option v-for="item in issueStatus1" :key="item.id" :label="item.cnName" :value="item.id" style="width:495px" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明:" label-width="50px" class="labletop">
          <el-input v-model="content" type="textarea" style="width:495px" maxlength="200" show-word-limit ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="openProbelmStatusCannel">取 消</el-button >
        <el-button type="primary" @click="openProbelmStatusSure" >确 定</el-button >
      </div>
    </el-dialog>
    <!-- 指定提修改放弹出的数据 -->
    <el-dialog v-dialogDrag :visible.sync="openModify" :close-on-click-modal="false" :close-on-press-escape="false" title="修改方" >
      <el-form>
        <el-form-item label="处理问题类型：" label-width="150px">
          <el-radio-group v-model="issueSelect">
            <el-radio label="目前选中"></el-radio>
            <el-radio label="当前页"></el-radio>
            <el-radio label="全部"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="指定修改方：" label-width="150px">
          <el-select v-model="modifierIds" size="small" filterable placeholder="请指定修改方">
            <!-- <el-option v-for="(item, index) in specModifierList" :key="index" :label="item.name" :value="item.userId"> </el-option> -->
            <el-option-group
              v-for="group in specModifierList"
              :key="group.label"
              :label="group.label"
            >
              <el-option v-for="item in group.options" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
            </el-option-group>
          </el-select>
          
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="openModifyCannel">取 消</el-button >
        <el-button type="primary" @click="openModifySure">确 定</el-button>
      </div>
    </el-dialog>
    <detailItem ref="detailItem" @update="update" @refresh="refresh" v-if="showDetail"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { checkPermission } from "@/utils/routeAuth";
import checkLabel2D from "./component/2DcheckLabel.vue";
import problemStatistics from "./component/problemStatistics.vue";
import detailItem from "./component/detailItem.vue"
import requestIssueMg from "@/CommonDP/service/question-service";
import question from "@/xgzdService/question-service";
import moment from 'moment';
export default {
  name: 'issuelist',
  components:{checkLabel2D,detailItem,problemStatistics},
  data() {
      return {
        updateKey: 0,
        bodyLoading: false,
        tableRefresh: 0,
        navList: ["2D问题", "3D问题", "文件问题",'问题统计'],
        active: "0",
        searchFileName:'',
        mapType:['dwg'],
        modelType:['rvt','skp'],
        fileType:['doc','xls','ppt','pdf','txt','docx','xlsx','pptx',"png", "jpg", "gif", "jpeg", "bmp", "tiff"],
        typeArray:['dwg'],

        excelSelectVisiable: false, // 导出
        exportExcel: ["目前选中", "当前页", "全部"], // 导出excel
        exportExcelradio: "", // 选中的导出类型
        excelDisable: false,
        multipleSelection:[],
        prjId:'',

        issueSelect: "目前选中",
        content: "",
        dialogFormVisible: false,
        issueidentity: "我是创建人",
        prostatus: "待修改",
        selectStatus: "", // 处理问题选中的问题状态
        issueStatus1: [],
        itemNme: "",
        openModify:false,
        ModifyRadios: [],
        modifierIds: "", // 修改方数据
        ModifyRadiosID: "",
        count:"",
        dataRangelist:["目前选中","当前页","全部"],
        dataRangelistIsgou:["目前选中","当前页","全部"],
        identitylist:["我是创建人","我是修改人"],
        prostatuslist:["待修改","已修改","已复核","无效","已取消"],
        prostatuslistS:["待修改","已修改","已复核","无效","已取消"],
        specModifierList:[],
        issueStatus:[],
        showDetail:false
      }
  },
  watch: {
    'prjInfo': {
      deep: true,
      handler: function ({prjId},oldValue) {
        if (prjId) {
          // debugger
          // // this.$store.dispatch('updateMessageObj',{ isShow:true,message:'数据加载中...'})
          // this.updateKey += 1
        }
      }
    }
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      messageInfo: state => state.XtDesign.messageObj,
      userInfo: state => state.user.userInfo
    }),
    isIssue(){
      return !checkPermission(':issueMg:issue')
    },
    isPeople(){
      return !checkPermission(':issueMg:people')
    },
    isExport(){
      return !checkPermission(':issueMg:export')
    },
    exportParams(){
      const fileTypeList = this.typeArray;
      const data = this.$refs.checkLabel2D;
      const {statusIdList,problemTypeIdList,modifierIdList,qmTypeIdList,specIdList,stageChildIdList,createUserIdList,sourceList} =data.selectForm,
      params={ prjId: this.prjId, pageNum: data.page.pageNum, pageSize: data.page.pageSize, statusIdList, keyword:this.searchFileName, problemTypeIdList, modifierIdList, qmTypeIdList, specIdList, stageChildIdList, createUserIdList, sourceList, idList:[], fileTypeList }
      return params
    },
    issueParams(){
      var toStatusid = "";
      for (const a of this.issueStatus) {
        if (a.id === this.selectStatus) {
          this.itemNme = a.cnName;
        }
        if (a.cnName === this.prostatus) {
          toStatusid = a.id;
        }
      }
      var uodataType = "";
      if (this.issueidentity === "我是创建人") {
        uodataType = "1";
      } else {
        uodataType = "2";
      }
      const fileTypeList = this.typeArray;
      const data = this.$refs.checkLabel2D;
      const {statusIdList,problemTypeIdList,modifierIdList,qmTypeIdList,specIdList,stageChildIdList,createUserIdList,sourceList} =data.selectForm,
      params={ prjId: this.prjId, content: this.content, statusId: toStatusid, statusName: this.prostatus,  toStatusId: this.selectStatus, toStatusName: this.itemNme, pageNum: data.page.pageNum, pageSize: data.page.pageSize, statusIdList, fileName:this.searchFileName, problemTypeIdList, modifierIdList, qmTypeIdList, specIdList, stageChildIdList, createUserIdList, sourceList, idList:[], fileTypeList }
      return params
    },
    modifyParams(){
      let modifierList =[]
      if(this.modifierIds){
        let list = [...this.specModifierList[0].options, ...this.specModifierList[1].options]
        let selectItem = list.find(sor=>sor.id == this.modifierIds)
        let obj={modifierId:this.modifierIds, modifierName:selectItem.cnName, type:selectItem.remark };
        // let obj={modifierId:this.modifierIds, modifierName:this.specModifierList.find(sor=>sor.userId == this.modifierIds).name };
        modifierList.push(obj)
      }
      const data = this.$refs.checkLabel2D;
      const {statusIdList,problemTypeIdList,modifierIdList,qmTypeIdList,specIdList,stageChildIdList,createUserIdList,sourceList} =data.selectForm,
      params = { 
                  prjId: this.prjId, 
                  pageNum: data.page.pageNum, 
                  pageSize: data.page.pageSize, 
                  statusIdList, 
                  fileName:this.searchFileName, 
                  problemTypeIdList, 
                  modifierIdList, 
                  qmTypeIdList, 
                  specIdList, 
                  stageChildIdList, 
                  createUserIdList, 
                  sourceList, 
                  idList:[], 
                  modifierList, 
                  idList:[], 
                  operType:'', 
        }
      return params
    }
  },
  created(){
    this.prjId = this.prjInfo.prjId;
    const index = this.$route.query.issueType
    if(!!index){
      this.navhandleClick(index)
    }
  },
  methods:{
    async deleteQuestion() {
      await this.$confirm("确定删除选中的问题？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      this.bodyLoading = true
      const idList = this.multipleSelection.map(ele=>ele.questionId)
      const res = await requestIssueMg.DrawingQuestionDelete(idList).catch(err => {
        console.error('批量删除失败')
      })
      this.bodyLoading = false
      if (res?.result == '0') {
        this.$message.success('批量删除成功')
        this.tableRefresh = (this.tableRefresh + 1) % 2
      }
    },
    navhandleClick(index){
      this.active = index;
      this.multipleSelection =[]
      if(index =='0'){
        this.typeArray = this.mapType
      }else if(index =='1'){
        this.typeArray = this.modelType
      }else if(index =='2'){
        this.typeArray = this.fileType
      }
      if(this.active!=3){
        this.$nextTick(()=>{
          this.$refs.checkLabel2D.getInit()
        })
      }else{
        this.$nextTick(()=>{
          this.$refs.problemStatistics.init()
        })        
      }
      
    },
    // 搜索人员
    changeclear(val) {
      this.searchFileName=val
      setTimeout(()=>{
        this.$refs.checkLabel2D.getInit()
      },0)
    },
    refresh(){
      this.$refs.checkLabel2D.refresh()
    },
    openDetail(row,data){
      this.showDetail=true
      this.$nextTick(()=>{
         this.$refs.detailItem.openDetail(row,data)
        // this.$refs.detailItem.showDetail=true
        // this.$refs.detailItem.detailType='问题详情';
        // this.$nextTick(()=>{
        //   this.$refs.detailItem.navType()
        //   this.$refs.detailItem.$refs.navdetailVue.getDetailInit(row.questionId,row.prjId,row.fileId)
        // })
      })
    },
    update(){
      this.$nextTick(()=>{
        this.$refs.checkLabel2D.getInit()
      })
    },
    // 回车
    submitForm() {
      this.$refs.checkLabel2D.getInit()
    },
    checkData(val){
      this.multipleSelection = val
    },
    openProbelmStatus(){
      this.queryDict1();
    },
    // 字典
    queryDict() {
      const data=this.$refs.checkLabel2D;
      this.specModifierList=data.dicData.modifierList;
      this.openModify = true;
      this.issueSelect = "目前选中";
      this.modifierIds = [];
      console.log(this.modifierList);
      // requestIssueMg.getUserInfoListByPrjId(this.prjId).then(res => {
      //   this.ModifyRadios = res.data; // 总修改人
      //   this.issueSelect = "目前选中";
      //   this.modifierIds = [];
      //   this.openModify = true;
      // });
    },
    async queryDict1() {
      const res = await requestIssueMg.queryDict(this.prjId)
      if(res.result == '0'){
        this.issueStatus = res.data; // 问题状态
        this.issueidentity = "我是创建人";
        this.prostatus = "待修改";
        this.selectStatus = "";
        this.issueStatus1 = [];
        this.content = "";
        if(this.multipleSelection.length === 0){
          this.issueSelect = "当前页"
          this.dataRangelist=this.dataRangelistIsgou.slice(1,3)
        }else{
          this.issueSelect = "目前选中";
          this.dataRangelist=this.dataRangelistIsgou
        }
        await this.queryCount();
        this.issueStatus1=this.issueStatus.filter(item=>item.cnName!==this.prostatus)
        // for (var i = 0; i < this.issueStatus.length; i++) {
        //   if (this.issueStatus[i].cnName === "无效") {
        //     this.issueStatus1.push(this.issueStatus[i]);
        //   }
        // }
        this.prostatuslist=this.prostatuslistS;
        this.dialogFormVisible = true;
      }
    },
    async queryCount(){
      if(this.issueSelect==='当前页'){
        this.issueParams.idList=this.$refs.checkLabel2D.tabData.map(ele=>ele.questionId);
      }else if(this.issueSelect==='目前选中'){
        this.issueParams.idList=this.multipleSelection.map(ele=>ele.questionId)
      }else{
        this.issueParams.idList=[]
      }
      const res = await question.batchUpdatecount(this.issueParams)
      if(res.result == '0'){
        this.count=res.data
      }
    },
    openModifyPartyName(){
      this.queryDict()
    },
    acexportExcel(){
      this.exportExcelradio = "目前选中";
      this.excelSelectVisiable = true;
    },
    // 导出取消
    excelSelectCannel() {
      this.excelSelectVisiable = false;
      this.exportExcelradio = "";
    },
    // 导出确定
    async excelSelectSure() {
      this.excelDisable = true;
      if (this.exportExcelradio === "目前选中") {
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请选择需要导出的问题');
          this.excelDisable = false;
          return;
        } else{
          this.exportParams.idList=this.multipleSelection.map(ele=>ele.questionId)
        }
      }else if(this.exportExcelradio === "当前页"){
        const data = this.$refs.checkLabel2D.tabData;
        if(data.length == 0){
          this.$message.warning('暂无数据');
          this.excelDisable = false;
          return
        }else{
          this.exportParams.idList=this.$refs.checkLabel2D.tabData.map(ele=>ele.questionId);
        }
      }else{
        this.exportParams.idList=[];
      }
      const {data} = await question.exportExcel(JSON.stringify(this.exportParams))
      await this.excelExport(data)
    },
    async excelExport(excelId){
      const {data} = await question.getExportStatus(excelId)
      if(data===0){
        setTimeout(async () => {
          await this.excelExport(excelId)
        }, 1000);
      }else if(data===2){
        this.$message.error('导出失败')
      }else{
        const result = await question.downloadExce(excelId)
        const toDay = moment().format("YYYYMMDD")
        const fileName = `问题列表-${this.navList[this.active]}-${toDay}-${this.userInfo.name}`;
        if ("msSaveOrOpenBlob" in navigator) { // 兼容ie
          window.navigator.msSaveOrOpenBlob(result, fileName);
          return;
        } else {
          const link = document.createElement("a");
          const blob = result;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.excelDisable = false;
          this.excelSelectVisiable = false;
        }
      }
    },
    // 切换问题状态 联动得到 批量更改问题状态下拉数据
    async changeprostatus(item) {
      this.prostatus=item
      this.issueStatus1 = [];
      this.selectStatus = "";
      await this.queryCount();
      this.issueStatus1=this.issueStatus.filter(item=>item.cnName!==this.prostatus)
      // if (this.issueidentity === "我是创建人") {
      //   if (this.prostatus === "待修改") {
      //     for (var i = 0; i < this.issueStatus.length; i++) {
      //       if (this.issueStatus[i].cnName === "无效") {
      //         this.issueStatus1.push(this.issueStatus[i]);
      //       }
      //     }
      //   } else if (this.prostatus === "已修改") {
      //     for (var e = 0; e < this.issueStatus.length; e++) {
      //       if (
      //         this.issueStatus[e].cnName === "待修改" ||
      //         this.issueStatus[e].cnName === "已复核" ||
      //         this.issueStatus[e].cnName === "无效"
      //       ) {
      //         this.issueStatus1.push(this.issueStatus[e]);
      //       }
      //     }
      //   } else if (this.prostatus === "已复核") {
      //     for (var f = 0; f < this.issueStatus.length; f++) {
      //       if (
      //         this.issueStatus[f].cnName === "待修改" ||
      //         this.issueStatus[f].cnName === "无效"
      //       ) {
      //         this.issueStatus1.push(this.issueStatus[f]);
      //       }
      //     }
      //   } else if (this.prostatus === "无效") {
      //     for (var a = 0; a < this.issueStatus.length; a++) {
      //       if (this.issueStatus[a].cnName === "待修改") {
      //         this.issueStatus1.push(this.issueStatus[a]);
      //       }
      //     }
      //   }
      // } else {
      //   if (this.prostatus === "待修改") {
      //     for (var b = 0; b < this.issueStatus.length; b++) {
      //       if (this.issueStatus[b].cnName === "已修改") {
      //         this.issueStatus1.push(this.issueStatus[b]);
      //       }
      //     }
      //   } else if (this.prostatus === "已修改") {
      //     for (var c = 0; c < this.issueStatus.length; c++) {
      //       if (this.issueStatus[c].cnName === "待修改") {
      //         this.issueStatus1.push(this.issueStatus[c]);
      //       }
      //     }
      //   }
      // }
    },
    // 问题处理 取消
    openProbelmStatusCannel() {
      this.dialogFormVisible = false;
    },
    openProbelmStatusSure() {
      if(this.count === 0) {
        this.$message.warning('当前没有符合筛选条件的数据')
        return 
      }
      this.batchProcessing();
    },
    // 批量操作  问题处理
    async batchProcessing() {
      if (this.issueSelect === "目前选中") {
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请选择需要修改的问题');
          this.dialogFormVisible = false;
          return;
        } else{
          this.issueParams.idList=this.multipleSelection.map(ele=>ele.questionId)
        }
      }else if(this.issueSelect === "当前页"){
        const data = this.$refs.checkLabel2D.tabData;
        if(data.length == 0){
          this.$message.warning('暂无数据');
          return
        }else{
          this.issueParams.idList=this.$refs.checkLabel2D.tabData.map(ele=>ele.questionId);
        }
      }else{
        this.issueParams.idList=[];
      }
      const result = await question.DrawingQuestionStatusBatchEdit( this.issueParams );
      if (result.result === "0") {
        this.dialogFormVisible = false;
        this.$message.success(`共${result.data}条数据修改成功`);
        this.$nextTick(()=>{
          this.$refs.checkLabel2D.getInitOld()
        })
      }
    },
    // 修改人 取消
    openModifyCannel() {
      this.openModify = false;
    },
    // 修改人 确定
    openModifySure() {
      if (!this.modifierIds || this.modifierIds.length === 0) {
        this.$message({ message: "请选择修改方", type: "warning" });
        return;
      } else {
        this.ModifyBatchProcessing();
      }
    },
    async ModifyBatchProcessing() {
      if (this.issueSelect === "目前选中") {
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请选择需要指定的问题');
          this.dialogFormVisible = false;
          return;
        } else{
          this.modifyParams.idList=this.multipleSelection.map(ele=>ele.questionId)
        }
      }else if(this.issueSelect === "当前页"){
        const data = this.$refs.checkLabel2D.tabData;
        if(data.length == 0){
          this.$message.warning('暂无数据');
          return
        }else{
          this.modifyParams.idList=this.$refs.checkLabel2D.tabData.map(ele=>ele.questionId);
        }
      }else{
        this.modifyParams.idList=[];
      }
      const result = await requestIssueMg.DrawingQuestionquesti(this.modifyParams);
      if (result.result === "0") {
        this.openModify = false;
        // 请求成功啦，再次读取数据
        this.$message.success('修改成功');
        this.$nextTick(()=>{
          this.$refs.checkLabel2D.getInitOld()
        })
      }
    },
    changeDataRange(item){
      this.issueSelect=item
      this.queryCount()
    },
    // 切换处理人身份 问题状态一直保持待修改
    changeIdentity(item){
      this.issueidentity=item;
      if(item=='我是创建人'){
        this.prostatuslist=this.prostatuslistS
      }else{
        this.prostatuslist=this.prostatuslistS.slice(0,2)
      }
      this.prostatus = "待修改";
      this.changeprostatus('待修改');
    },
  },
  
}
</script>
<style lang="scss" scoped>
#issueMgContainer{
  width:100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: auto;
  position: relative;
  background-color: #fff;
  .el-row {
    width: 100%;
    height: 100%;
    .el-col {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
    }
  }
  .mainHeader{
    width: 100%;
    height: 50px; 
    padding-left: 30px ;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid rgba(211, 217, 232, 0.77);
  }
  .mainBody {
    width: 100%;
    height: calc(100% - 50px);
    display: flex;
    flex-direction: row;
    // position: relative;
    .left{
      width: 100%;
      height: 100%;
      transition: all .3s;
    }
    .showStyleDetail{
      width: calc(100% - 428px);
      height: 100%;
      transition: all .3s;
    }
    .mainNav{
      width: 100%;
      height: 45px;
      padding: 0 15px;
      border-bottom: 1px solid #E8EBEF;
      display: flex;
      flex-direction: row;
      box-sizing: border-box;
      // justify-content: space-between;
      align-items: center;
      font-size: 16px;
      li{
        width: 90px;
        box-sizing: border-box;
        height: 100%;
        line-height: 100%;
        cursor: pointer;
        margin-right: 10px;
        padding: 15px 8px 0;
        font-size: 14px;
        user-select: none;
        text-align: center;
      }
      .isActive{
        color: #3873FE;
        border-bottom: 2px solid #3873FE;
        // transition: all .3s;
      }
    }
    .issueOpter{
      width: 100%;
      height: 45px;
      padding: 0 15px;
      display: flex;
      flex-direction: row;
      align-items: center;
      box-sizing: border-box;
      .searchRight{
        margin-left: auto;
      }
    }
    .issueTable{
      width: 100%;
      height: calc(100% - 95px);
      overflow: auto;
    }
    .issueDetail{
      width: 438px;
      height: 100%;
      border-left: 1px solid #F5F5F5;
      box-sizing: border-box;
      z-index: 10;
      overflow: auto;
      
    }
  }
}
.openModify,
.excelType {
    width: 500px;
    padding-bottom: 10px;
}
.excelType {
    border-bottom: 1px dashed #ccc;
}
.piliangshuli{
  /deep/ .el-form-item{
    margin-bottom: 8px !important
  }
  /deep/ .el-dialog__body{
    padding: 10px 20px;
    box-sizing: border-box;
  }
  /deep/ .el-button--primary{
    background:#4777E7;
		border-color:#4777E7;
  }
  /deep/ .el-button--primary:hover{
    background:#7397EC;
    border-color:#7397EC;
  }
  .labletop{
    /deep/ .el-form-item__label{
      float: none !important;
      display: inline-block !important;
			text-align: left !important;
    }
    /deep/ .el-form-item__content{
      margin-left: 0 !important;
    }
    /deep/ .el-select{
      width :495px
    }
    /deep/ .el-textarea__inner{
      height: 150px;
    }
  }
  li{
    border: 1px solid #BDC7DA;
    height:28px;
    line-height: 26px;
    text-align: center;
    border-radius:20px;
    color:#323232;
    display: inline-block;
    margin-right: 12px;
    background: #fff;
    cursor: pointer;
  }
  .dataRangeStyle{
    li{
      width:72px;      
    }
    .dataRangeSelect{
      background:rgba(56, 115, 254, 0.1);
      border: 1px solid #5C8CFE;
      color: #3873FE;
    }
  }
  .identityStyle{
    li{
      width:92px;
    }
    .identitySelect{
      background:rgba(56, 115, 254, 0.1);
      border: 1px solid #5C8CFE;
      color: #3873FE;
    }
  }
  .prostatusStyle{
    li{
      width:66px;
    }
    .prostatusSelect{
      background:rgba(56, 115, 254, 0.1);
      border: 1px solid #5C8CFE;
      color: #3873FE;
    }
  }
  .countStyle{
    height:44px;
    line-height:44px;
    background:rgba(212, 217, 236, 0.21);
    color:#3873FE;
    text-align: center;
    font-size: 14px;
    margin-top:22px;
    margin-bottom:10px;
    span{
      color:#EE4C4C;
    }
  }
}
</style>

